import { useEffect, useState } from 'react';
import { Loader2, History } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';
import { Button } from '../../ui/button';
import { fetchBillingActivity } from '../../../lib/customerBillingApi';
import BillingHistorySection from './BillingHistorySection';

export default function BillingHistoryDialog({ organizationId, triggerClassName }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payments, setPayments] = useState([]);
  const [activity, setActivity] = useState([]);

  useEffect(() => {
    if (!open || !organizationId) return;
    let cancelled = false;
    setLoading(true);
    fetchBillingActivity(organizationId)
      .then((data) => {
        if (cancelled) return;
        setPayments(data.payments || []);
        setActivity(data.activity || []);
      })
      .catch(() => {
        if (!cancelled) {
          setPayments([]);
          setActivity([]);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, organizationId]);

  return (
    <>
      <Button
        type="button"
        variant="outline"
        className={triggerClassName}
        disabled={!organizationId}
        onClick={() => setOpen(true)}
      >
        <History className="w-4 h-4 mr-2" />
        Billing history
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Billing history</DialogTitle>
            <DialogDescription>
              Payments, plan upgrades, downgrades, add-on changes, and cancellations for this
              workspace.
            </DialogDescription>
          </DialogHeader>
          {loading ? (
            <div className="flex justify-center py-16">
              <Loader2 className="w-8 h-8 animate-spin text-slate-400" />
            </div>
          ) : (
            <BillingHistorySection payments={payments} activity={activity} compact />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
